// Source of truth, kept in sync manually:
// https://github.com/wix-private/promote-server/blob/master/email-address-validation-app/resources/blacklisted-domains.txt
export const MISTYPED_EMAIL_DOMAINS = new Set([
    'aaol.com',
    'ail.com',
    'aol.con',
    'aool.com',
    'gail.com',
    'gamail.com',
    'gamil.com',
    'gemail.com',
    'gmai.com',
    'gmail.cm',
    'gmail.cmo',
    'gmail.co',
    'gmail.com.com',
    'gmail.con',
    'gmailc.om',
    'gmaill.com',
    'gmaim.com',
    'gmal.com',
    'gmali.com',
    'gmaol.com',
    'gmeil.com',
    'gmial.com',
    'gmqil.com',
    'gmsil.com',
    'gnail.com',
    'hitmail.com',
    'homail.com',
    'hotmai.com',
    'hotmail.con',
    'hotmaill.com',
    'hotmal.com',
    'hotmali.com',
    'hotmaol.com',
    'hotmial.com',
    'htmail.com',
    'iclod.com',
    'iclou.com',
    'icloud.con',
    'icloude.com',
    'iclould.com',
    'icolud.com',
    'icoud.com',
    'ivloud.com',
    'otlook.com',
    'outllook.com',
    'outlok.com',
    'outlook.con',
    'outlookk.com',
    'outloook.com',
    'outook.com',
    'test.com',
    'yagoo.com',
    'yaho.com',
    'yahoo.con',
    'yahooo.com',
    'yahou.com',
    'yaoo.com',
    'yhaoo.com',
    'yhoo.com'
]);

//# sourceMappingURL=mistyped-email-domains.js.map